define('presentation/settings/voicemailBoxes/viewModels/addVoicemailBoxSubscribersViewModel',[
    'businessServices/state/modelStateObserver',
    'common/collections/collectionSorter',
    'common/promises/promiseFactory',
    'common/storage/commonState',
    'constants/voicemailConstants',
    'presentation/common/subscriberSelection/viewModels/subscriberSelectionViewModel',
    'presentation/settings/voicemailBoxes/facades/addVoicemailBoxSubscribersFacade',
], function () {
    return function () {
        const self = this;

        const ModelStateObserverConstructor = require('businessServices/state/modelStateObserver');
        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();
        const SorterConstructor = require('common/collections/collectionSorter');
        const _sorter = new SorterConstructor();

        const _commonState = require('common/storage/commonState');
        const _i18n = require('i18next');
        const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');

        let _facade = null;
        let _voicemailBoxId = null;
        let _voicemailBoxOwnerId = null;

        const _initializeSubscribers = () => {
            return _promiseFactory.defer((promise) => {
                if (_voicemailBoxId === null) {
                    const userId = _sessionAccountInfo.userId();
                    const initialMembers = [{"subscriberId": userId}];
                    _setSelectedSubscribers(initialMembers);
                    self.subscriberSelectionViewModel.activate(self.selectedSubscribers())
                        .fail(promise.reject)
                        .done(() => {
                            self.modelStateObserver.addChildObserver(self.subscriberSelectionViewModel.modelStateObserver);
                            promise.resolve();
                        });
                } else {
                    _facade.getVoicemailBoxSubscribers(_voicemailBoxId)
                        .fail(promise.reject)
                        .done((subscriberInfo) => {
                            const subscribers = subscriberInfo.subscribers;
                            const subscribersLog = subscriberInfo.subscribersLog;
                            _setSelectedSubscribers(subscribers);
                            self.subscriberSelectionViewModel.activate(self.selectedSubscribers())
                                .fail(promise.reject)
                                .done(() => {
                                    self.subscriberSelectionViewModel.setSubscribersLog(subscribersLog);
                                    self.modelStateObserver.addChildObserver(self.subscriberSelectionViewModel.modelStateObserver);
                                    promise.resolve();
                                });
                        });
                }
            });
        };

        const _setSelectedSubscribers = (subscribers) => {
            self.selectedSubscribers = ko.pureComputed(() => {
                let selectedSubscribers = subscribers.map(subscriber => {
                    const commonStateItem = _commonState.get(subscriber.subscriberId);
                    const avatar = commonStateItem.type === "user" ? {avatar: commonStateItem.avatar()} : {};
                    const ownerProperties = commonStateItem.id !== _voicemailBoxOwnerId ? {} : {
                        readOnly: true,
                        removeToolTipText: self.isOwnerSelf() ?
                            _i18n.t('addVoicemailBox:lastMemberSelf') :
                            _i18n.t('addVoicemailBox:lastMember')
                    };

                    return Object.assign({}, subscriber, {
                            id: commonStateItem.id,
                            subscriberType: commonStateItem.type,
                            displayName: commonStateItem.name()
                        },
                        avatar,
                        ownerProperties);
                });

                _sorter.sort(selectedSubscribers, "displayName", true);
                return selectedSubscribers;
            });
        };

        self.modelStateObserver = null;
        self.subscriberSelectionViewModel = null;
        self.isOwnerSelf = ko.observable(false);

        self.save = (voicemailBoxId) => {
            return _promiseFactory.deferIndefinitely((promise) => {
                if (voicemailBoxId !== undefined) {
                    _voicemailBoxId = voicemailBoxId;
                }
                self.subscriberSelectionViewModel.getSubscribers()
                    .fail(promise.reject)
                    .done((subscribers) => {
                        _facade.saveVoicemailBoxSubscribers(_voicemailBoxId, subscribers)
                            .fail(promise.reject)
                            .done(() => {
                                self.modelStateObserver.saveData();
                                promise.resolve();
                            });
                    });
            });
        };

        self.activate = (voicemailBoxId, owningUserId) => {
            _voicemailBoxId = voicemailBoxId;
            _voicemailBoxOwnerId = owningUserId;
            self.isOwnerSelf(owningUserId === _sessionAccountInfo.userId());

            const FacadeConstructor = require('presentation/settings/voicemailBoxes/facades/addVoicemailBoxSubscribersFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            const SubscriberSelectionConstructor = require('presentation/common/subscriberSelection/viewModels/subscriberSelectionViewModel');
            self.subscriberSelectionViewModel = new SubscriberSelectionConstructor();

            return _initialize();
        };

        const _initialize = () => {
            self.modelStateObserver = new ModelStateObserverConstructor(self, true);

            _initializeSubscribers()
                .done(self.modelStateObserver.commitData)
                .fail((error) => {
                    throw error;
                });

            return _promiseFactory.wait();
        };
    };
});

